import React from 'react';
import { MessageCircle } from 'lucide-react';
import { motion } from 'motion/react';

export const WhatsAppButton: React.FC = () => {
  return (
    <motion.a
      href="https://wa.me/56948758084?text=Hola,%20necesito%20ayuda%20con%20mi%20pedido%20o%20cotizaci%C3%B3n"
      target="_blank"
      rel="noopener noreferrer"
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.9 }}
      className="fixed bottom-8 right-8 z-50 bg-[#25D366] text-white p-4 rounded-full shadow-2xl flex items-center justify-center"
      aria-label="Contactar por WhatsApp"
    >
      <MessageCircle size={32} fill="currentColor" aria-hidden="true" />
      <span className="absolute right-full mr-4 bg-white text-brand-dark-blue px-4 py-2 rounded-xl text-sm font-bold shadow-lg whitespace-nowrap hidden md:block">
        ¿Necesita ayuda? ¡Hablemos!
      </span>
    </motion.a>
  );
};
